export default "__VITE_ASSET__Do6r9g7n__"